




const Neet_StudyMaterials = ({ studyMaterials }) => {
    return (
        <div className='mx-'>
            <div className='History-container-box'>
                <div className='card History-card container'>
                    {/* Course Table Start */}
                    <table className="table" border="1">
                        <thead>
                            <tr className='text-center'>
                                <th colSpan="4" className='History1-course-heading table-border'>IMPORTANT RESOURCES FOR NEET PREPARATION</th>
                            </tr>
                        </thead>
                        <thead >
                            <tr >
                                <th className='History2-course-heading table-border'>S.No.</th>
                                <th className='History2-course-heading table-border'>File Name</th>
                                <th className='History2-course-heading table-border'>DownLoad</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studyMaterials?.map((course, index) => (
                                <tr key={index}>
                                    <td className='table-border'>{index + 1}</td>
                                    <td className='table-border table-data2'>{course.FileTitle}</td>
                                    <td className='table-border d-flex justify-content-center align-items-center '>
                                        <button className=' btn btn-sm fw-bold px-4 btn-danger' onClick={() => window.open(course.FilePath)}>Click</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* Course Table End */}
                </div>
            </div>



        </div>
    )
}

export default Neet_StudyMaterials